import React from 'react'
import Button from './button'

const RegisterButton = (props) => {
    const href = () => {
        const params = new URLSearchParams()
        if (props.campaign) params.append('origin', props.campaign)
        if (props.email) params.append('_email', props.email)
        if (props.lang) params.append('lang', props.lang)
        if (props.tier) params.append('tier', props.tier)

        const queryString = params.toString()
        return `/signup${queryString ? `?${queryString}` : ''}`
    }

    return (
        <Button {...props} href={!props.disabled && (props.url ? props.url : href())}>
            {props.children}
        </Button>
    )
}

export default RegisterButton
